import React from 'react';
import { usePortalAuth } from '../../contexts/PortalAuthContext';
import { PrayerRequestButton } from '../Prayer';
import '../../styles/portal-brand.css';

const PortalFooter: React.FC = () => {
  const { user } = usePortalAuth();

  // Determine portal source based on customer type
  const getPortalSource = () => {
    const customerType = user?.customer?.customer_type;
    if (customerType === 'RETAIL_PARTNER') return 'retail_partner';
    return 'wholesale';
  };

  return (
    <>
      {/* Prayer Request Button */}
      {user && (
        <PrayerRequestButton
          portalSource={getPortalSource()}
          userName={user.name}
          userEmail={user.email}
          submitEndpoint="/prayer-requests/"
        />
      )}

      <footer style={styles.footer}>
        <div style={styles.company}>
          Red Bridge Farm Feed Co.
        </div>
      <div style={styles.address}>
        145 W 3rd Ave, Kettle Falls, WA 99141
      </div>
      <div style={styles.contact}>
        <a href="tel:509-738-9004" style={styles.link}>509-738-9004</a>
        {' | '}
        <a href="mailto:office@theredbridgefarm.com" style={styles.link}>
          office@theredbridgefarm.com
        </a>
      </div>

      <div style={styles.separator}></div>

      <div style={styles.tagline}>
        Non-GMO, Soy & Corn-Free Feeds
      </div>
      <div style={styles.motto}>
        Healthy Feed. Healthy Food. Healthy Families.
      </div>

      <div style={styles.copyright}>
        &copy; {new Date().getFullYear()} Red Bridge Farm Feed Co. All rights reserved.
      </div>
    </footer>
    </>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  footer: {
    backgroundColor: '#3F2021',
    color: '#FAF9F6',
    padding: '2rem',
    textAlign: 'center',
    marginTop: '3rem',
    borderTop: '3px solid #E73C3E',
  },
  company: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginBottom: '0.5rem',
    color: '#FFFFFF',
  },
  address: {
    fontSize: '0.95rem',
    marginBottom: '0.5rem',
    color: '#FAF9F6',
  },
  contact: {
    fontSize: '0.95rem',
    marginBottom: '1.5rem',
    color: '#FAF9F6',
  },
  link: {
    color: '#508590',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
  },
  separator: {
    width: '100px',
    height: '2px',
    backgroundColor: '#C3AD8B',
    margin: '1.5rem auto',
  },
  tagline: {
    fontSize: '1.05rem',
    fontWeight: 500,
    color: '#C3AD8B',
    marginTop: '1rem',
  },
  motto: {
    fontSize: '0.95rem',
    fontStyle: 'italic',
    color: '#6C8062',
    marginTop: '0.5rem',
  },
  copyright: {
    fontSize: '0.85rem',
    color: '#C3AD8B',
    marginTop: '2rem',
    paddingTop: '1rem',
    borderTop: '1px solid rgba(195, 173, 139, 0.3)',
  },
};

export default PortalFooter;
